import store from '../store'
import {
    SET_PHOTO_TO_UPLOAD,
    CLEAR_PHOTO_TO_UPLOAD,
} from '../reducers/photo-upload'

/**
 * Set photo to upload in base64 format
 * @param {string|null} photoBase64
 * @param {string} rootType
 * @param {string} rootId
 */
export const setPhotoToUpload = (photoBase64, rootType, rootId) => {
    store.dispatch({
        type: SET_PHOTO_TO_UPLOAD,
        photoBase64,
        rootType,
        rootId,
    })
}

/**
 * Clear photo to upload
 */
export const clearPhotoToUpload = () => {
    store.dispatch({
        type: CLEAR_PHOTO_TO_UPLOAD,
    })
}
